import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const StyledAuthLayout = styled("div")`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
`;

const StyledAuthLayoutMainContainer = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 100vh;
  height: 100%;
  overflow: auto;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.common.white};

  @media (min-width: 768px) {
    padding: 32px 60px;
  }

  @media (min-width: 1024px) {
    width: 50%;
  }
`;

const StyledAuthLayoutImgContainer = styled("div")`
  width: 50%;
  max-height: 100vh;
  height: 100%;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #c3eeff;


  & > .auth-layout__img {
    width: 100%;
    height: 80%;
    object-position: left;
    object-fit: cover;
  }

  @media (min-width: 1024px) {
    display: flex;
  }
`;

const StyledAuthLayoutHeader = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 1024px) {
    margin-bottom: 40px;
  }
`;

const StyledAuthLayoutHeaderLogo = styled(Link)`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  height: 50px;

  & > svg {
    width: 100%;
  }
`;

const StyledAuthLayoutContentContainer = styled("div")`
  width: 100%;

  &.auth-layout-content-container_centered {
    height: 100%;

    @media (min-width: 768px) {
      height: auto;
      margin: auto;
    }
  }
`;

export {
  StyledAuthLayout,
  StyledAuthLayoutMainContainer,
  StyledAuthLayoutImgContainer,
  StyledAuthLayoutHeader,
  StyledAuthLayoutHeaderLogo,
  StyledAuthLayoutContentContainer,
};
